
import { RESET_UPLOAD_MANUAL_ORDER ,UPLOAD_MANUAL_ORDER_ERROR,UPLOAD_MANUAL_ORDER_SUCCESS,UPLOAD_MANUAL_ORDER_REQUEST,RESET_UPLOAD_MANUAL_ERROR} from "../actions/action-type";


const initalState = {
    uploadManualOrderResponse: [],
    isuploadManualOrderError: false,
    isuploadManualOrderSuccess: false,
    isuploadManualOrderLoading: false,
    errorDetails:{}
};

const uploadManualOrderReducer = (state = initalState, { type, uploadManualOrderResponse,errorDetails }) => {
    switch (type) {
        case UPLOAD_MANUAL_ORDER_REQUEST:
            return {
                ...state,
                isuploadManualOrderLoading: true,
                isuploadManualOrderError: false,
                isuploadManualOrderSuccess: false
            };
        case UPLOAD_MANUAL_ORDER_SUCCESS:
            return {
                ...state,
                uploadManualOrderResponse: uploadManualOrderResponse,
                isuploadManualOrderLoading: false,
                isuploadManualOrderError: false,
                isuploadManualOrderSuccess: true,
                errorDetails:{}
            };
        case UPLOAD_MANUAL_ORDER_ERROR:
            return {
                ...state,
                isuploadManualOrderLoading: false,
                isuploadManualOrderError: true,
                isuploadManualOrderSuccess: false,
                errorDetails:errorDetails
            };
            case RESET_UPLOAD_MANUAL_ORDER:            
            return initalState
            
            case RESET_UPLOAD_MANUAL_ERROR:            
            return {
                ...state,
                isuploadManualOrderError: false,
                isuploadManualOrderSuccess:false
              };                   
        default:
            return state;
    }
};

export default uploadManualOrderReducer;